import { IMetrics } from '../context/dashboard/DashboardCtx/interfaces';

export default (metrics: IMetrics): boolean => {
  const isFeedback = !!metrics?.extractionClassFeedbacks?.length;

  return isFeedback;
};
